// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useTenantStore } from "@/providers/TenantContextProvider";
import { useContext } from "react";
import { AuthContext } from "@/providers/AuthContextProvider";
import { IPermissions } from "@/types/keycloak";
export function useScheduledEventPermissions() {
    var tenantId = useTenantStore()[0];
    var authContext = useContext(AuthContext);
    /**
     * Permissions
     */
    var canWriteScheduledEvent = authContext.isAuthorized(true, tenantId, IPermissions.SCHEDULED_EVENT_WRITE);
    var canCreateScheduledEvent = authContext.isAuthorized(true, tenantId, IPermissions.SCHEDULED_EVENT_CREATE);
    var canDeleteScheduledEvent = authContext.isAuthorized(true, tenantId, IPermissions.SCHEDULED_EVENT_DELETE);
    var showScheduledEventColumns = authContext.isAuthorized(true, tenantId, IPermissions.EE_SCHEDULED_EVENT_COLUMNS);
    /**
     * Permissions
     */
    return {
        canWriteScheduledEvent: canWriteScheduledEvent,
        canCreateScheduledEvent: canCreateScheduledEvent,
        canDeleteScheduledEvent: canDeleteScheduledEvent,
        showScheduledEventColumns: showScheduledEventColumns,
    };
}
